import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FileUploadResponse } from '@models';
import { AttachmentService, NotificationService } from '@services';

@Component({
  selector: 'app-dataset-form-attachment-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
  imports: [
    MatDialogModule,
    MatListModule,
    MatButtonModule,
    MatProgressBarModule,
    MatIconModule,
  ],
})
export class DatasetFormAttachmentCreateComponent implements OnInit {
  dialogRef = inject<MatDialogRef<DatasetFormAttachmentCreateComponent>>(MatDialogRef);
  data = inject<{
    datasetId: string;
    files: FileList;
    recordId?: string;
    prefix?: string;
  }>(MAT_DIALOG_DATA);

  attachmentService = inject(AttachmentService);
  notificationService = inject(NotificationService);

  results = signal<FileUploadResponse[]>([]);
  failures = computed(() => this.results().filter((r) => !!r.errorMessage));
  isLoading = signal(true);

  ngOnInit(): void {
    this.attachmentService
      .createAttachment(
        this.data.datasetId,
        this.data.files,
        this.data.recordId,
        new Date(),
        this.data.prefix,
      )
      .subscribe({
        next: (responses: FileUploadResponse[]) => {
          this.results.set(responses);

          if (this.failures().length) {
            this.notificationService.error(
              'Failed to upload one or multiple files.',
            );
          } else {
            this.dialogRef.close();
          }
        },
        error: (err) => {
          console.error(err);
          this.notificationService.error('Failed to upload files.');
          this.dialogRef.close();
        },
      })
      .add(() => {
        this.isLoading.set(false);
      });
  }
}
